import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import { CustomAuthCallbackComponent } from '@sc/feature-auth-okta';
import { FitterRouterService } from '@sc/feature-fitter-path-router-system';

const CALLBACK_PATH = 'login/callback';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: FitterRouterService.loginPageRoute,
    loadChildren: () =>
      import('@sc/feature-fitter-login').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Login',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: FitterRouterService.planningPageRoute,
    loadChildren: () =>
      import('@sc/feature-fitter-planning').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Planning',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: FitterRouterService.settingsPageRoute,
    loadChildren: () =>
      import('@sc/feature-fitter-settings').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Settings',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: `${FitterRouterService.callToActionPageRoute}/:encryptedInfo`,
    loadChildren: () =>
      import('@sc/feature-cta-fitter').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Home',
    },
  },
  {
    path: `${FitterRouterService.callToActionPageRoute}`,
    loadChildren: () =>
      import('@sc/feature-cta-fitter').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Home',
    },
  },
  {
    path: FitterRouterService.searchDossiersPageRoute,
    loadChildren: () =>
      import('@sc/feature-fitter-search-dossier').then(
        (module) => module.routes
      ),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.DossierSearch',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: FitterRouterService.dashboardPageRoute,
    loadChildren: () =>
      import('@sc/feature-fitter-dashboard').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Dashboard',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: FitterRouterService.preferences,
    loadChildren: () =>
      import('@sc/feature-preferences').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Preferences',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: FitterRouterService.sitePlan,
    loadChildren: () =>
      import('@sc/feature-fitter-site-plan').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.SitePlan',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: `${FitterRouterService.sidexaPageRoute}/:licensePlate`,
    loadChildren: () =>
      import('@sc/feature-sidexa').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Sidexa',
    },
  },
  {
    path: CALLBACK_PATH,
    component: CustomAuthCallbackComponent,
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
